module.exports = __webpack_public_path__ + "d4e6796852482791fc5f783cf6b50043.pdf";